const WORDS = ["The geometry of life", "Moral geometry", "Myth-tech", "Sound & Light", "Field work", "The angle of the voice", "The long, hard home"];

export default function Marquee() {
  const row = (k) => (
    <div className="flex items-center shrink-0" key={k} aria-hidden={k === 1}>
      {WORDS.map((w) => (
        <span key={w} className="flex items-center">
          <span className="f-display font-black uppercase text-5xl sm:text-7xl lg:text-8xl px-8 outline-text">{w}</span>
          <svg width="28" height="28" viewBox="0 0 28 28" className="shrink-0"><circle cx="14" cy="14" r="12" fill="none" stroke="var(--bone)" strokeWidth="1"/><line x1="0" y1="14" x2="28" y2="14" stroke="var(--bone)" strokeWidth="1"/><circle cx="14" cy="14" r="2.5" fill="var(--signal)"/></svg>
        </span>
      ))}
    </div>
  );
  return (
    <section className="border-y border-[var(--line)] py-8 overflow-hidden" aria-label="Themes" data-testid="editorial-marquee">
      <div className="marquee-track">{row(0)}{row(1)}</div>
    </section>
  );
}
